import React from "react";

import CatalogCrudPage from "./CatalogCrudPage";
import { categoriesService } from "../../services";

export default function CategoriesPage() {
  return (
    <CatalogCrudPage
      title="Categorias"
      subtitle="Administracion de categorias de productos"
      addTabPath="/settings/categories"
      addTabLabel="Categorias"
      service={categoriesService}
      hasDescription
      viewPerms={["view_categories"]}
      managePerms={["manage_categories"]}
    />
  );
}
